import {
  ScheduleSlotActionLabels,
  ScheduleSlotButton,
} from '@/components/ui/schedule-slot-button.component';
import { SchedulesSearchSlot } from '@/app/(main)/(pages)/_components/schedules/_types/schedule-slot.type';
import { dateFormatter } from '@/utils/formatters/date';
import { cn } from '@/utils/cn-tw-merge';

interface ScheduledDayColumnProps {
  slots: SchedulesSearchSlot[];
  visibleSlotsLimit: number;
  markedSlotIds: ReadonlySet<string>;
  busySlotIds: ReadonlySet<string>;
  slotClassName?: string;
  slotDataTestId?: string;
  slotActionLabels?: ScheduleSlotActionLabels;
  onSelectSlot: (slot: SchedulesSearchSlot) => void;
}

export function ScheduledDayColumn({
  slots,
  visibleSlotsLimit,
  markedSlotIds,
  busySlotIds,
  slotClassName,
  slotDataTestId,
  slotActionLabels,
  onSelectSlot,
}: ScheduledDayColumnProps) {
  const visibleSlots = slots.slice(0, visibleSlotsLimit);

  return (
    <div className="flex flex-1 flex-col items-center gap-2 min-w-0">
      {visibleSlots.map((slot) => (
        <ScheduleSlotButton
          key={slot.id}
          start={dateFormatter(slot.start, 'HH:mm')}
          selected={markedSlotIds.has(slot.id)}
          busy={busySlotIds.has(slot.id)}
          dataTestId={slotDataTestId}
          actionLabels={slotActionLabels}
          className={cn('w-full', slotClassName)}
          onClick={() => onSelectSlot(slot)}
        />
      ))}
    </div>
  );
}
